'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M1005.254 18.746c-24.992-24.994-65.516-24.994-90.508 0l-240 240-66.746-66.746-128 111.24-454.48 138.32c-15.16 4.612-25.52 18.596-25.52 34.44v32c0 137.828 53.674 267.408 151.132 364.868 97.462 97.458 227.040 151.132 364.868 151.132h32c15.846 0 29.826-10.36 34.44-25.518l138.322-454.484 111.238-127.998-66.746-66.746 240-240c24.994-24.994 24.994-65.514 0-90.508zM521.326 952h-5.326c-53.22 0-104.998-9.328-153.502-27.16l149.502-348.84-248.036 297.642c-21.926-15.182-42.658-32.428-61.918-51.688s-36.506-39.992-51.688-61.918l297.642-248.036-348.84 149.502c-17.832-48.504-27.16-100.284-27.16-153.502v-5.326l465.7-141.734 125.362 125.362-141.736 465.698z' })
    ));
};